import type { FC } from 'react';
import React from 'react';
import { Container } from '@mui/material';
import { Button, HeaderBreadcrumbs, Iconify } from '@pflegenavi/web-components';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { YEAR_MONTH_FORMAT } from '@pflegenavi/shared/constants';
import { useLocale } from '@pflegenavi/frontend/localization';
import { useTranslation } from 'react-i18next';
import { useInitializeResidents } from '../hooks/useUnitializeResidents';
import { ServiceProviderReceiptBatchOverviewTable } from '../components/receipt-batch-table/ServiceProviderReceiptBatchOverviewTable';
import { Link as RouterLink } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DashboardPageProps {}

export const DashboardPage: FC<DashboardPageProps> = () => {
  const locale = useLocale();
  const { t } = useTranslation();

  useInitializeResidents();

  return (
    <Container sx={{ maxWidth: 1400 }}>
      <HeaderBreadcrumbs
        heading={t('dashboard.main')}
        links={[
          {
            name: t('dashboard.main'),
            href: spAppMainPages.DASHBOARD,
          },
          { name: new Date().toLocaleDateString(locale, YEAR_MONTH_FORMAT) },
        ]}
        action={
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            // @ts-expect-error component type mismatch
            component={RouterLink}
            to={spAppMainPages.RECEIPT_BATCH_NEW}
          >
            {t('sp-web-app.receipt-batch.new')}
          </Button>
        }
      />
      <ServiceProviderReceiptBatchOverviewTable />
    </Container>
  );
};
